<template>
  <div>
    <van-popup
      v-model="dialogVisible"
      :close-on-click-overlay="false">
      <div class="title">{{$t('compliance.title')}}</div>
      <div class="content">
        <p>{{$t("compliance.paragraph1")}}</p>
        <p>{{$t('compliance.paragraph2')}}</p>
        <p>{{$t('compliance.paragraph3')}}</p>
        <p>{{$t('compliance.paragraph4')}}</p>
        <p>{{$t('compliance.paragraph5')}}</p>
        <p>{{$t('compliance.paragraph6')}}</p>
        <p>{{$t('compliance.paragraph7')}}</p>
        <p>{{$t('compliance.paragraph8')}}</p>
        <p>{{$t('compliance.paragraph9')}}</p>
      </div>
      <span class="btns">
        <div class="abandon" @click="abandon">{{$t('abandon')}}</div>
        <div class="confirm" @click="confirm">{{$t('confirm')}}</div>
      </span>
    </van-popup>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dialogVisible: true
    }
  },
  mounted () {
    this.dialogVisible = localStorage.getItem('dialogVisible') ? JSON.parse(localStorage.getItem('dialogVisible')) : true
  },
  methods: {
    abandon () {
      this.dialogVisible = false
      setTimeout(() => {
        this.dialogVisible = true
      }, 300)
    },
    confirm () {
      localStorage.setItem('dialogVisible', JSON.stringify(false))
      this.dialogVisible = false
    }

  }
}
</script>

<style scoped lang="less">
.van-popup {
  height: 75%;
  width: 92%;
  border-radius: 0.11rem;
  padding: 0.43rem;
  text-align: left;
  .title {
    color: #141617;
    font-size: 0.43rem;
    font-weight: 700;
    margin-bottom: 0.32rem;
  }
  .content {
    color: #666666;
    font-size: 0.32rem;
    height: 80%;
    overflow: auto;
    p {
      margin-bottom: 0.13rem;
    }
  }
  .btns {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-top: 0.46rem;
    padding-bottom: 0.27rem;
    width: 100%;
    height: 10%;
    // background-color: pink;
    .abandon,
    .confirm {
      width: 45%;
      height: 1.07rem;
      border-radius: 0.59rem;
      background: #fff;
      border: 1px solid #E2E2E2;
      color: #141617;
      font-size: 0.37rem;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .confirm {
      background-color: #C91818;
      color: #fff;
    }
  }
}
</style>
